import React from 'react';
import { Box, Typography } from '@mui/material';
import Order from '@components/order/models/list/Order';
import { CheckingStatusIcon, ConfirmedStatusIcon, DeniedStatusIcon } from '@components/order/components/common/OrderStatusIcons';

interface OrderListItemIconProps {
    order: Order;
}

const OrderListItemIcon: React.FC<OrderListItemIconProps> = ({ order }) => {
    const renderIcon = (order: Order) => {
        if (order.isConfirmed === true) {
            return <ConfirmedStatusIcon height={36} width={44} />
        }
        else if (order.isConfirmed === false) {
            return <DeniedStatusIcon height={36} width={44} />
        }
        return <CheckingStatusIcon height={36} width={44} />
    }

    const getText = (order: Order) => {
        if (order.isConfirmed === true) {
            return "potvrđena"
        }
        else if (order.isConfirmed === false) {
            return "odbijena"
        }
        return "na čekanju"
    }

    return (
        <Box display={"flex"} width={62} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} gap={0.5}>
            {renderIcon(order)}
            <Typography variant='caption' color={"text.secondary"}>{getText(order)}</Typography>
        </Box>
    )
}

export default OrderListItemIcon;